/**
 * @fileoverview PATCH handler for the "/app_settings/custom_attribute_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsCustomAttributeSchemaCacheKeys } from "./constants";
import type {
  PatchAppSettingsCustomAttributeSchemaProps,
  PatchAppSettingsCustomAttributeSchemaResult,
} from "./types";

export const patchAppSettingsCustomAttributeSchema = reactQueryMutationAdapter(
  appSettingsCustomAttributeSchemaCacheKeys,
  (props: PatchAppSettingsCustomAttributeSchemaProps): Promise<PatchAppSettingsCustomAttributeSchemaResult> => {
    return fetch("/app_settings/custom_attribute_schema", "PATCH", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
